import type { UseFormRegister, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { ProfileFormValues } from "./profileFormTypes";
import { Input } from "@/components/ui";

interface DocumentFieldsProps {
  register: UseFormRegister<ProfileFormValues>;
  errors?: FieldErrors<ProfileFormValues>;
}

/** Identity document fields (canonical API: document_*). */
export function DocumentFields({ register, errors }: DocumentFieldsProps) {
  const { t } = useTranslation("settings");

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      <Input
        {...register("document_type")}
        label={t("forms.document.type")}
        required
        placeholder={t("forms.document.typePh")}
        error={errors?.document_type?.message}
      />
      <Input
        {...register("document_number")}
        label={t("forms.document.number")}
        required
        placeholder={t("forms.document.numberPh")}
        error={errors?.document_number?.message}
      />
      <Input
        {...register("document_issuer")}
        label={t("forms.document.issuer")}
        required
        placeholder={t("forms.document.issuerPh")}
        error={errors?.document_issuer?.message}
      />
      <Input
        {...register("document_issue_date")}
        label={t("forms.document.issueDate")}
        required
        type="date"
        error={errors?.document_issue_date?.message}
      />
      <Input
        {...register("document_expiry_date")}
        label={t("forms.document.expiryDate")}
        required
        type="date"
        error={errors?.document_expiry_date?.message}
      />
    </div>
  );
}
